<template>
  <div class="sidebar">
    <div class="item">
      <div class="item__header">
        <p>Novos usuários</p>
        <img src="@/assets/icons/enjoy.svg" />
      </div>
      <div class="item__count">
        <h1>{{ users.new }}</h1>
        <p>{{ users.new_of_the_week }} na última semana</p>
      </div>
    </div>
    <div class="item">
      <div class="item__header">
        <p>Treinamentos</p>
        <img src="@/assets/icons/win.svg" />
      </div>
      <div class="item__count">
        <h1>{{ finishedTrainings }}</h1>
        <p>pessoas concluíram treinamentos.</p>
      </div>
      <div class="item__detail">
        <router-link
          :to="{ name: 'training-reports.index' }"
          tag="button"
          type="button"
          >ver detalhes</router-link
        >
      </div>
    </div>
    <div class="item">
      <div class="item__header">
        <p>Campanhas</p>
      </div>
      <div class="item__count">
        <h1>{{ campaignsCount }}</h1>
        <p>campanhas realizadas</p>
      </div>
      <div class="item__detail">
        <router-link :to="{ name: 'campaign.index' }" tag="button" type="button"
          >ver detalhes</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'sidebar',
  computed: mapState({
    campaignsCount: (state) => state.dashboard.campaignsCount,
    users: (state) => state.dashboard.users,
    finishedTrainings: (state) => state.dashboard.finishedTrainings,
  }),
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  top: var(--toolbar-height);
  right: 0;
  background: #fff;
  width: 260px;
  padding: 1.8em;
  border-radius: 0 0 0 32px;
  box-shadow: 0px 2px 14px rgba(21, 23, 64, 0.03);

  .item {
    padding-bottom: 1em;
    margin-bottom: 1em;

    &:not(:last-child) {
      border-bottom: 1px solid #dddeea;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1em;

      p {
        font-weight: 600;
      }
    }

    &__count {
      h1 {
        line-height: 1;
        font-size: 2.5em;
      }

      p {
        font-size: 0.9em;
        color: var(--text-color-light);
      }
    }

    &__detail {
      margin-top: 16px;

      button {
        background: transparent;
        border: 1px solid #dddeea;
        border-radius: 6px;
        padding: 8px 12px;
        color: var(--text-color-light);
        cursor: pointer;
        transition: 200ms ease-in-out;

        &:hover {
          color: var(--color-primary);
        }
      }
    }
  }
}
</style>
